/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ucwords, reactSelectCustomStyleCms } from 'helper';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { get } from 'session';
import * as actions from '../../actions';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';

function BusinessActivity({
  data,
  setFormData,
  activityId,
  businessLineId,
  getNecessaryFieldsList,
}) {
  const dataGrossAmount = +_.get(data, 'gross_amount', 0);
  const dataDetails = _.get(data, 'details', {});
  const [necessaryFields, setNecessaryFields] = useState([]);
  const filteredNecessaryFields = necessaryFields.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = necessaryFields.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const multiplierQuantityMatrix = _.get(data, 'details.quantity_matrix');

  useEffect(() => {
    const applicationStatusId = get('applicationStatusId');
    if (!businessLineId || !applicationStatusId) return;
    const args = {
      business_line_id: businessLineId,
      application_status_id: applicationStatusId,
    };
    getNecessaryFieldsList(args, ({ data: fields }) => {
      setNecessaryFields(fields);
    });
  }, [businessLineId]);

  useEffect(() => {
    setFormData((prev) => {
      const prevActivities = _.get(prev, 'activities', []);
      const activities = prevActivities.map((item) => {
        const activityDetailsQuantityMatrix = _.get(item, 'details.quantity_matrix', {});
        const multiplierQuantityMatrix = Object.values(activityDetailsQuantityMatrix ?? {})
          .flatMap(item => _.isArray(item) ? item : [])
          .reduce((acc, { multiplier, value }) => {
            if (multiplier && !Number.isNaN(value)) {
              acc[multiplier] = +value;
            }
            return acc;
          }, {});

        if (item.activity_id === activityId) {
          return {
            ...item,
            details: {
              ...item.details,
              quantity_matrix: multiplierQuantityMatrix
            },
          };
        }
        return item;
      });

      return {
        ...prev,
        activities,
      };
    });
  }, []);

  const onChangeQuantityMatrix = (key, value) => {
    // ({ target: { value } }) => {
      setFormData((prev) => {
        const prevActivities = _.get(prev, 'activities', []);
        const activities = prevActivities.map((item) => {
          if (item.activity_id === activityId) {
            const activityDetailsQuantityMatrix = _.get(item, 'details.quantity_matrix', {});
            return {
              ...item,
              details: {
                ..._.get(item, 'details', {}),
                quantity_matrix: {
                  ...activityDetailsQuantityMatrix,
                  [key]: value,
                },
              },
            };
          }
          return item;
        });

        return {
          ...prev,
          activities,
        };
      });
    };

  const selectOptions = (list) => {
    const newList = [];

    if (_.isEmpty(list)) return false;

    list.map((listItem) => {
      return newList.push({
        label: ucwords(_.get(listItem, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: listItem.multiplier,
      });
    });
    return newList;
  };

  const hasGrossKey = filteredNecessaryFields.some((item) =>
    _.get(item, 'multiplier', '').includes('gross_amount_')
  );

  const onChangeGross = (values) => {
    const { value } = values;
    setFormData((prev) => {
      const prevActivities = _.get(prev, 'activities', []);
      const activities = prevActivities.map((item) => {
        if (item.activity_id === activityId) {
          return {
            ...item,
            gross_amount: value,
          };
        }
        return item;
      });

      return {
        ...prev,
        activities,
      };
    });
  };

  const handleChange = (key, value) => {
    setFormData((prev) => {
      const prevActivities = _.get(prev, 'activities', []);
      if (_.isEmpty(prevActivities)) return prev;

      const newActivities = prevActivities.map((prevActivity) => {
        const prevActivityId = _.get(prevActivity, 'activity_id');
        if (prevActivityId !== activityId) return prevActivity;
        const prevActivityDetails = _.get(prevActivity, 'details', {});
        const newDetails = { ...prevActivityDetails, [key]: value };
        const gross_amount = Object.keys(newDetails)
          .filter((k) => k.includes('gross_amount_'))
          .reduce((total, k) => {
            const amount = new Decimal(newDetails[k] || '0');
            return new Decimal(total).plus(amount);
          }, new Decimal('0'))
          .toString();

        return {
          ...prevActivity,
          // Computes gross amount if has gross amount details
          ...(hasGrossKey ? { gross_amount } : {}),
          details: newDetails,
        };
      });

      return {
        ...prev,
        activities: newActivities,
      };
    });
  };

  const onChange = (e) => {
    const { name, value } = e;
    handleChange(name, value);
  };

  const onChangeSelect = (key) => (e) => {
    const value = _.get(e, 'value');
    handleChange(key, value);
  };

  return (
    <>
      {/* Business Activity Field */}
      <div className="px-3">
        <div className="form-row">
          <div className="form-group col-sm-12 col-md-6">
            <label className="form-label">Gross Amount</label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={onChangeGross}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              disabled={hasGrossKey}
              value={dataGrossAmount}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
        </div>
        <div className="form-row">
          {filteredNecessaryFields?.map((item) => {
            const multiplier = _.get(item, 'multiplier');
            const options = _.get(item, 'options');
            const hasGrossKey = multiplier.includes('gross_amount_');

            if (options) {
              return (
                <div className="form-group col-sm-12 col-md-6" key={multiplier}>
                  <label
                    htmlFor={multiplier}
                    className="form-label text-capitalize"
                  >
                    {multiplier.replace(/_/g, ' ')}{' '}
                  </label>
                  <Select
                    styles={reactSelectCustomStyleCms()}
                    options={selectOptions(options)}
                    value={selectOptions(options).find((option) => {
                      const itemValue = dataDetails[multiplier];
                      return itemValue === _.get(option, 'value');
                    })}
                    onChange={onChangeSelect(multiplier)}
                    components={{ IndicatorSeparator: () => null }}
                    placeholder="Select"
                  />
                </div>
              );
            }

            return (
              <div className="form-group col-sm-12 col-md-6" key={multiplier}>
                <label
                  htmlFor={_.get(item, 'label')}
                  className="form-label"
                >
                  {multiplier.replace(/_/g, ' ')}{' '}
                </label>
                <NumberFormat
                  name={multiplier}
                  id={multiplier}
                  placeholder="0.00"
                  className="form-control"
                  onValueChange={(values) => {
                    const { value } = values;
                    const prop = {
                      name: multiplier,
                      value,
                    };
                    onChange(prop);
                  }}
                  displayType="input"
                  decimalScale={2}
                  isNumericString
                  allowNegative
                  thousandSeparator
                  allowLeadingZeros
                  prefix={hasGrossKey ? '₱ ' : ''}
                  value={dataDetails[multiplier]}
                  isAllowed={(values) => {
                    const { value } = values;
                    if (!hasGrossKey || !value) return true;
                    const val = new Decimal(value);
                    const max = new Decimal(MAX_LIMIT);
                    return value === undefined || val.lte(max);
                  }}
                />
              </div>
            );
          })}
          {!_.isEmpty(filteredQuantityMatrix) ? (
            filteredQuantityMatrix.map((item) => {
              const multiplier = _.get(item, 'multiplier', '');

              return (
                <React.Fragment>
                  <div className='col-12 form-group'>
                    <label className='form-label text-capitalize'>
                      {multiplier || ''}
                    </label>
                    <div className="w-100 border rounded-lg">
                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                        <thead>
                          <tr className="form-group">
                            <td className="col-4 text-center form-label border-right">Unit</td>
                            <td className="col-4 text-center form-label border-right">Capacity</td>
                            <td className="col-4 text-center form-label">Number of Units</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.quantity_matrix.map((quantityMatrixItem) => {
                            const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                            return (
                              <tr key={quantityMatrixMultiplier} className="border-top form-group">
                                <td className="text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'unit')}
                                </td>
                                <td className="text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'capacity')}
                                </td>
                                <td className="text-left form-label">
                                  <NumberFormat
                                    name={quantityMatrixMultiplier}
                                    id={quantityMatrixMultiplier}
                                    placeholder=""
                                    className="form-control"
                                    onValueChange={({ floatValue }) => {
                                      onChangeQuantityMatrix(quantityMatrixMultiplier, floatValue);
                                    }}
                                    displayType="input"
                                    thousandSeparator
                                    allowLeadingZeros
                                    isNumericString
                                    value={multiplierQuantityMatrix[quantityMatrixMultiplier] ?? ''}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </React.Fragment>
              )
            })
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
}

BusinessActivity.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  activityId: PropTypes.string.isRequired,
  businessLineId: PropTypes.number.isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions }),
]);

export default enhance(BusinessActivity);
